<template>
  <svg
    class="icon-case-page-activities"
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    width="500.000000pt"
    height="500.000000pt"
    viewBox="0 0 500.000000 500.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
      <path
        d="M2310 4185 c-344 -73 -617 -326 -715 -660 -33 -112 -44 -295 -25 -412 15 -93 60 -227 102 -303 73 -130 742 -1178 769 -1202 18 -18 40 -28 59 -28 19 0 41 10 59 28 36 33 729 1125 787 1239 73 143 89 221 88 418 0 155 -3 178 -27 258 -97 317 -329 549 -644 643 -74 23 -111 27 -238 30 -102 2 -171 -1 -215 -11z m293 -430 c126 -26 243 -107 316 -216 221 -332 -20 -780 -419 -780 -400 0 -641 448 -419 780 52 78 116 133 204 176 111 54 201 65 318 40z"
      />
      <path
        d="M1915 1879 c-400 -44 -707 -126 -802 -216 -133 -126 68 -257 507 -332 683 -116 1676 -75 2110 88 138 52 212 122 196 186 -29 115 -336 217 -816 270 -74 8 -156 15 -181 15 l-45 0 -107 -169 c-59 -92 -124 -184 -146 -204 -36 -32 -92 -57 -131 -57 -39 0 -95 25 -131 57 -22 20 -87 112 -146 204 l-107 169 -60 -1 c-34 -1 -97 -6 -141 -10z"
      />
    </g>
  </svg>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.icon-case-page-activities {
  display: block;
  height: 46px;
  width: 46px;
}
</style>
